import $ from '../utils/net';
import Config from './config';
import {h, Component} from 'preact';
import Ticket from "./ticket";
import formatOdd from "./odds-format";
import { Trans } from "@lingui/react/macro";
import Observer from "../skins/awrabet/utils/observer";


export default class TicketConfirmService extends Component {
    state = {
        id: null,
        expires: 0,
        countervalue: 0,
        counterinterval: null
    };

    componentWillMount() {
        // document.querySelector('html').style.overflow = 'hidden';
        Ticket.subscribeSystemChanges(this.cb = (data) => {
            this.setState(this.state);
        });

        Observer.subscribe('ticket-confirm', () => {
            this.updateExpirationTime(Ticket.status.data[0].idbets, Ticket.status.data[0].expires);
            this.setState({});
        });
    }

    updateExpirationTime(id, time) {
        if (time > this.state.expires && this.counterinterval == null) {
            this.state.id = id;
            this.state.expires = time;
            this.startCountdown();
        }
    }

    startCountdown() {
        this.tickCountdown();
        this.counterinterval = setInterval(
            () => {
                this.tickCountdown();

                if (this.state.countervalue == 0) {
                    // this.ticketCancelAction();
					// Me ne sbatto non lo riabilito. Ti nascondo solo il popup, se la deve vedere PHP.
                }
            },
            1000
        );
    }

    tickCountdown() {
        this.state.countervalue = parseInt((this.state.expires - new Date().getTime())/1000);

        if (this.state.countervalue <= 0) {
            this.state.countervalue = 0;
        }

        this.setState(this.state);
    }

    ticketConfirmAction() {
        $.getJSON(Config.softionAPI+'/schedina/accettaRiserva/'+ this.state.id +'?json', (something, data) => {
            Ticket.status.type = 'done';
            Ticket.status.data = Ticket.status.data[0];
            Ticket.signal();

            clearInterval(this.counterinterval);
            this.counterinterval = null;
            this.setState(this.state);
        });
    }

    ticketCancelAction() {
        $.getJSON(Config.softionAPI+'/schedina/rifiutaRiserva/'+ this.state.id +'?json', (something, data) => {
            Ticket.status.type = 'error';
            Ticket.status.data.body = 'ticket-refused';
            Ticket.signal();

            clearInterval(this.counterinterval);
            this.counterinterval = null;
            this.setState(this.state);
        });
    }

    render() {
        if (!Ticket.needsUserApproval()) {
            return null;
        }
        if (this.state.countervalue <= 0) {
            return null;
        }

        const getOdd = row => parseFloat(!!row['outcome']? row['outcome']['odd'] : row['quota']);
        const getOldOdd = row => {
            //> Quota live ma non ha la "vecchia"
            if (!!row['outcome'] && !row['outcome']['vecchia']) {
                return null;

            //> Quota prematch ma non ha la "vecchia"
            } else if (!row['outcome'] && !row['vecchia']) {
                return null;
            }

            //> Una delle due lo ha per forza
            return parseFloat(!!row['outcome']? row['outcome']['vecchia'] : row['vecchia']);
        };
        const getMatchName = row => !!row['event']? row['event']['name'] : row['evento'];
        const getMarketName = row => !!row['outcome']? row['outcome']['market'] : row['scommessa'];
        const getOutcomeName = row => !!row['outcome']? row['outcome']['name'] : row['segno'];

        return <div class="absolute inset-0 bg-black/60" style="z-index:9998">
            <div id="betslip-user-confirm" class="absolute left-1/2 -translate-x-1/2 bg-white text-black top-[100px] w-[500px]" style="box-shadow: 0px 0px 5px #000;">
                <h2 style="font-size:18px;padding:8px 10px 5px">
                    <span class="block text-black"><strong>TicketID</strong>: {Ticket.status.data[0].code}</span>
                    <span class="block text-black"><strong>Bet Amount</strong>: {Ticket.status.data[0].importo_scommesso}</span>
                    <span class="block text-black"><strong>Win Amount</strong>: {Ticket.status.data[0].importo_vincita}</span>
                </h2>

                {Object.entries(Ticket.status.data[0].dettaglio).map(([outcomeid,outcome]) => <div class="text-xs">
                    <div>
                        <div class="p-1">
                            <div class="flex flex-col">
                                <div class="flex flex-row break-words">
                                    <span class="w-3/5 flex-grow-0">
                                        <span class="px-1 font-bold">{!!outcome.codice? outcome.codice.padStart(5, '0') : 'live'}</span>
                                        <span class="px-2">{getMatchName(outcome)}</span>
                                    </span>
                                    <span class="w-1/5 flex-shrink-0 text-center break-words">
                                        <span>{getMarketName(outcome)} - </span>
                                        <span>{getOutcomeName(outcome)}</span>
                                    </span>
                                    <div class="w-1/5 flex-shrink-0 text-sm text-right">
                                        {!!getOldOdd(outcome) && <span class="line-through px-2">{formatOdd(getOldOdd(outcome))}</span>}
                                        <span class="font-bold px-1">{formatOdd(getOdd(outcome))}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>)}

                <div class="p-5 flex flex-row">
                    <span class="w-full text-center">
                        <button class="p-2 rounded text-white" onClick={e => this.ticketConfirmAction()} style="background:#008000;"><Trans>Conferma</Trans></button>
                    </span>
                    <span class="w-full text-center">
                        <button class="p-2 rounded text-white" onClick={e => this.ticketCancelAction()} style="background:#900"><Trans>Annulla ({this.state.countervalue})</Trans></button>
                    </span>
                </div>
            </div>
        </div>;
    }
}